export default {
    loadingCurrencies: false,
    currencies: [],
};